export default {
  // component: null,
  priority: 650,
  permissions: [
    "",
    "4803480369a631092ea7c907d110b609f34718ed18ea563ce2b513eadb6b717feb0469a631092ea7c907d110b609f34718ed18ea563ce2b513eadb6b717feb04",
  ], // TODO
  name: app.translate("routes.home.bulletin.Bulletin"),
  icon: "bulletin-board",
  drawer: true,
  path:"bulletin",
  description: `تابلو اعلانات: در این ماژول شما میتوانید با درج متن مورد نظر خود، آن را در زمان مشخصی به کاربران یا دپارتمان های خاصی آن را به نمایش درآورید. این ماژول میتوانید برای تبریک تولد به همکاران یا اطلاع رسانی هایی که باید به تمام سازمان یا دپارتمان خاصی اعلام شود، مورد استفاده قرار گیرد
  `,
};
